import '@/assets/less/index.less';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { ElMessage } from 'element-plus';
import 'element-plus/dist/index.css';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import i18n from "@/lang/index.js";
import App from './App.vue';
import router from './router';
import '@/permission.js';
import '@/utils/rem.js';
import { openBodyScroll, stopBodyScroll } from '@/tools/DialogScroll';
import VPreventReClick from '@/tools/v-preventReClick';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(VPreventReClick);
app.use(VueDOMPurifyHTML);
app.use(i18n);
app.provide('$message', ElMessage);
app.provide('openBodyScroll', openBodyScroll);
app.provide('stopBodyScroll', stopBodyScroll);
app.mount('#app');
console.log('NODE_ENV:', process.env.VITE_USER_NODE_ENV);